import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "section section--mini screen-start faq-groups" }

import "./FaqView.scss";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import faqs from "./faqs";

export default /*#__PURE__*/_defineComponent({
  __name: 'FaqView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(AdditionalLayout, { title: "FAQ" }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(faqs), (group, i) => {
          return (_openBlock(), _createBlock(_component_RouterLink, {
            to: `/faq/${i}`,
            key: i,
            type: "button",
            class: "faq-groups__item"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(group.title), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})